import { useAIRepoAccess } from './useAIRepoAccess';
import { useIndustryStreamAccess } from './useIndustryStreamAccess';

export const useAIQueryAccess = (): boolean => {
  const aIRepoAccess = useAIRepoAccess();
  const industryStreamAccess = useIndustryStreamAccess();
  return aIRepoAccess || industryStreamAccess;
};
